import { toast } from 'react-toastify';

const getCardNoDetailService = (actionCallback, cardNo, toggler) => {

    let data = {
        applicationId: localStorage.getItem('applicationId'),
        cardNumber: cardNo
    }
    let token = "Token " + localStorage.getItem('token')
    let baseUrl= localStorage.getItem('serviceUrl')

    fetch(baseUrl + "/rest/card/detailsByCardNumber", {
        method: 'post',
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token,
        }),
        body: JSON.stringify(data)
    })
        .then(res => {
            if (res.status === 200 ) {
                if(localStorage.getItem('cardNoToast')=== 'first'){
                    toast.success(res.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 2000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    localStorage.setItem('cardNoToast','second')
                }
                
                res.json().then(json => actionCallback(json, "success"))
            } 
            else if(res.status === 401){
                actionCallback("401", "sessionout")
                this.props.history.push('/SessionOut')
            }
            else if(res.status === 204){
                toast.error(res.headers.get('message'))
                actionCallback("204", "no-data")
            }
            else {
                toast.error(res.headers.get('message'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });  
                actionCallback("no body", "error")
            }
        })
}

export default getCardNoDetailService;


// WEBPACK FOOTER //
// ./src/services/components/card_no_service.js